import { B100, B400, DN40, DN50, DN600, G300, G400, N0, N200, N30A, N40, N500, N50A, N60A, N700, R300, R400, Y200, Y300 } from '@atlaskit/theme/colors';
var flagBackgroundColor = {
  error: {
    light: "var(--ds-background-danger-bold, ".concat(R400, ")"),
    dark: "var(--ds-background-danger-bold, ".concat(R300, ")")
  },
  info: {
    light: "var(--ds-background-neutral-bold, ".concat(N500, ")"),
    dark: "var(--ds-background-neutral-bold, ".concat(N500, ")")
  },
  normal: {
    light: "var(--ds-surface-overlay, ".concat(N0, ")"),
    dark: "var(--ds-surface-overlay, ".concat(DN50, ")")
  },
  success: {
    light: "var(--ds-background-success-bold, ".concat(G400, ")"),
    dark: "var(--ds-background-success-bold, ".concat(G300, ")")
  },
  warning: {
    light: "var(--ds-background-warning-bold, ".concat(Y200, ")"),
    dark: "var(--ds-background-warning-bold, ".concat(Y300, ")")
  }
};
export var getFlagBackgroundColor = function getFlagBackgroundColor(appearance, mode) {
  return flagBackgroundColor[appearance][mode];
}; // token set in flag.tsx instead

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

export var flagBorderColor = N60A;
export var flagShadowColor = N50A;
/* eslint-enable @atlaskit/design-system/ensure-design-token-usage */

var flagIconColor = {
  error: {
    light: "var(--ds-icon-inverse, ".concat(N0, ")"),
    dark: "var(--ds-icon-inverse, ".concat(DN40, ")")
  },
  info: {
    light: "var(--ds-icon-inverse, ".concat(N0, ")"),
    dark: "var(--ds-icon-inverse, ".concat(DN600, ")")
  },
  normal: {
    light: "var(--ds-icon-subtle, ".concat(N500, ")"),
    dark: "var(--ds-icon-subtle, ".concat(DN600, ")")
  },
  success: {
    light: "var(--ds-icon-inverse, ".concat(N0, ")"),
    dark: "var(--ds-icon-inverse, ".concat(DN40, ")")
  },
  warning: {
    light: "var(--ds-icon-warning-inverse, ".concat(N700, ")"),
    dark: "var(--ds-icon-warning-inverse, ".concat(DN40, ")")
  }
};
var flagTextColor = {
  error: {
    light: "var(--ds-text-inverse, ".concat(N0, ")"),
    dark: "var(--ds-text-inverse, ".concat(DN40, ")")
  },
  info: {
    light: "var(--ds-text-inverse, ".concat(N0, ")"),
    dark: "var(--ds-text-inverse, ".concat(DN600, ")")
  },
  normal: {
    light: "var(--ds-text-subtle, ".concat(N500, ")"),
    dark: "var(--ds-text-subtle, ".concat(DN600, ")")
  },
  success: {
    light: "var(--ds-text-inverse, ".concat(N0, ")"),
    dark: "var(--ds-text-inverse, ".concat(DN40, ")")
  },
  warning: {
    light: "var(--ds-text-warning-inverse, ".concat(N700, ")"),
    dark: "var(--ds-text-warning-inverse, ".concat(DN40, ")")
  }
};
export var getFlagTextColor = function getFlagTextColor(appearance, mode) {
  return flagTextColor[appearance][mode];
};
export var getFlagIconColor = function getFlagIconColor(appearance, mode) {
  return flagIconColor[appearance][mode];
};
var flagFocusRingColor = {
  error: {
    light: "var(--ds-border-focused, ".concat(N40, ")"),
    dark: "var(--ds-border-focused, ".concat(N40, ")")
  },
  info: {
    light: "var(--ds-border-focused, ".concat(N40, ")"),
    dark: "var(--ds-border-focused, ".concat(N40, ")")
  },
  normal: {
    light: "var(--ds-border-focused, ".concat(B100, ")"),
    dark: "var(--ds-border-focused, ".concat(B100, ")")
  },
  success: {
    light: "var(--ds-border-focused, ".concat(N40, ")"),
    dark: "var(--ds-border-focused, ".concat(N40, ")")
  },
  warning: {
    light: "var(--ds-border-focused, ".concat(N200, ")"),
    dark: "var(--ds-border-focused, ".concat(N200, ")")
  }
};
export var getFlagFocusRingColor = function getFlagFocusRingColor(appearance, mode) {
  return flagFocusRingColor[appearance][mode];
};
var lightButtonBackground = 'rgba(255, 255, 255, 0.08)'; // TODO: DSP-2519 Interaction tokens should be used for hovered and pressed states
// https://product-fabric.atlassian.net/browse/DSP-2519

var actionBackground = {
  success: {
    light: "var(--ds-background-neutral, ".concat(lightButtonBackground, ")"),
    dark: "var(--ds-background-neutral, ".concat(N30A, ")")
  },
  info: {
    light: "var(--ds-background-neutral, ".concat(lightButtonBackground, ")"),
    dark: "var(--ds-background-neutral, ".concat(lightButtonBackground, ")")
  },
  error: {
    light: "var(--ds-background-neutral, ".concat(lightButtonBackground, ")"),
    dark: "var(--ds-background-neutral, ".concat(N30A, ")")
  },
  warning: {
    light: "var(--ds-background-neutral, ".concat(N30A, ")"),
    dark: "var(--ds-background-neutral, ".concat(N30A, ")")
  },
  normal: {
    light: 'none',
    dark: 'none'
  }
};
var actionColor = {
  success: {
    light: "var(--ds-text-inverse, ".concat(N0, ")"),
    dark: "var(--ds-text-inverse, ".concat(DN40, ")")
  },
  info: {
    light: "var(--ds-text-inverse, ".concat(N0, ")"),
    dark: "var(--ds-text-inverse, ".concat(DN600, ")")
  },
  error: {
    light: "var(--ds-text-inverse, ".concat(N0, ")"),
    dark: "var(--ds-text-inverse, ".concat(DN600, ")")
  },
  warning: {
    light: "var(--ds-text-warning-inverse, ".concat(N700, ")"),
    dark: "var(--ds-text-warning-inverse, ".concat(DN40, ")")
  },
  normal: {
    light: "var(--ds-link, ".concat(B400, ")"),
    dark: "var(--ds-link, ".concat(B100, ")")
  }
};
export var getActionBackground = function getActionBackground(appearance, mode) {
  return actionBackground[appearance][mode];
};
export var getActionColor = function getActionColor(appearance, mode) {
  return actionColor[appearance][mode];
};